(ns frontend.ui.component.lp-portal.news-item.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [text-size color]]))

(defn card
  []
  ^{:media {{:screen :only :max-width :599px}
            {:height  :320px
             :padding :5px}}}
  {:background      (theme/color [:card :card :bg])
   :flex            :1
   :display         :flex
   :flex-direction  :column
   :height          :580px
   :border-radius   "16px"
   :text-decoration :none
   :position        :relative})

(defn cover-image
  []
  ^{:media {{:screen :only :max-width :599px}
            {:height :100%}}}
  {:height     :34.483%
   :border-radius "16px 16px 0 0"
   :object-fit :cover})

(defn text-container
  []
  ^{:media {{:screen :only :max-width :599px}
            {:position   :absolute
             :bottom     :5px
             :left       :5px
             :width      "calc(100% - 10px)"
             :background "rgba(0,0,0,0.5)"}}}
  {:display         :flex
   :flex-direction  :column
   :justify-content :space-between
   :padding         "28px 24px"
   :flex            :1
   :color           (theme/color [:text :primary :color])
   :position        :relative})

(defn card-admin-menu-container
  []
  {:position :absolute
   :right    :25px
   :top      :28px})

(defn title
  []
  ^{:media {{:screen :only :max-width :599px}
            {:line-height    :14px
             :font-family    :Arial
             :text-transform :uppercase
             :text-align     :center
             :margin-bottom  :24px
             :font-weight    :700
             :font-size      :12px
             :letter-spacing :2.2px
             :font-style     :normal
             :color          :white}}}
  {:font-size   (text-size :medium :size)
   :line-height (text-size :medium :height)})

(defn bottom-bar
  []
  ^{:media {{:screen :only :max-width :599px}
            {:height :initial
             :justify-content :center}}}
  {:display         :flex
   :justify-content :space-between
   :align-items     :flex-end
   :height          :36px})

(defn bottom-bar-left
  []
  ^{:media {{:screen :only :max-width :599px}
            {:flex-direction :row
             :gap :16px}}}
  {:display         :flex
   :flex-direction  :column
   :justify-content :space-between
   :text-transform  :uppercase
   :font-size       (text-size :xxxsmall :size)
   :font-weight     :700
   :letter-spacing  :0.1em
   :height          :100%})

(defn category
  []
  ^{:media {{:screen :only :max-width :599px}
            {:color :white}}}
  {:white-space :nowrap
   :color       (theme/color [:text :main :color])})

(defn date
  []
  ^{:media {{:screen :only :max-width :599px}
            {:color :white}}}
  {:color       (theme/color [:text :secondary :color])
   :white-space :nowrap})

(defn arrow-container
  []
  ^{:media {{:screen :only :max-width :599px}
            {:display :none}}}
  {:width      :28px
   :height     :16px
   :position   :relative
   :transition "transform .2s ease"
   :transform  "translateX(-8px)"})

(defn arrow-left
  []
  {:position         :absolute
   :width            :2px
   :height           :71%
   :margin-bottom    :-8%
   :right            :4px
   :bottom           :50%
   :background-color (theme/color [:link :main :color])
   :border-radius    :2px
   :transform        "rotate(-45deg)"})

(defn arrow-center
  []
  {:position         :absolute
   :height           :2px
   :margin-top       :-1px
   :top              :50%
   :width            :92%
   :border-radius    :2px
   :background-color (theme/color [:link :main :color])})

(defn arrow-right
  []
  {:position         :absolute
   :width            :2px
   :right            :4px
   :top              :50%
   :height           :71%
   :margin-top       :-8%
   :background-color (theme/color [:link :main :color])
   :border-radius    :2px
   :transform        "rotate(45deg)"})
